import { Locale, resolveLocale } from "backend/src/common/i18n";

export const PREFERRED_LOCALE_STORAGE_KEY = "preferredLocale";

type Listener = () => void;

const listeners = new Set<Listener>();

const getBrowserLanguages = (): readonly string[] => {
  if (typeof navigator === "undefined") {
    return [];
  }

  if (Array.isArray(navigator.languages) && navigator.languages.length > 0) {
    return navigator.languages;
  }

  return navigator.language ? [navigator.language] : [];
};

const getStoredPreferredLocale = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return localStorage.getItem(PREFERRED_LOCALE_STORAGE_KEY);
  } catch {
    return null;
  }
};

const persistPreferredLocale = (locale: Locale) => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    localStorage.setItem(PREFERRED_LOCALE_STORAGE_KEY, locale);
  } catch {
    // ignore storage failures
  }
};

let currentLocale: Locale = resolveLocale(
  getStoredPreferredLocale(),
  getBrowserLanguages(),
);

export const getCurrentLocale = (): Locale => currentLocale;

export const setCurrentLocale = (locale: Locale) => {
  if (locale === currentLocale) {
    return;
  }

  currentLocale = locale;
  persistPreferredLocale(locale);
  listeners.forEach((listener) => listener());
};

export const subscribeLocale = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
